import { useState, type MouseEvent } from 'react'
import { Button } from '@/components/ui/button';
import ContractPickerModal from '@/components/shared/contract-picker-modal';
import { useContractsData, useSelectedContract } from '@/hooks/api/use-contracts';
import { useRequestDocument } from '@/hooks/api/use-documents';

export interface RequestDocumentProps {
    title: string;
    /** Type de document demandé (`dispositions_particulieres`, `memo`…). */
    type: string;
}

const RequestDocument = (props: RequestDocumentProps) => {
    const { title, type } = props
    const contracts = useContractsData();
    const id_contrat = useSelectedContract()?.id;
    const requestDocument = useRequestDocument();
    const [pickerOpen, setPickerOpen] = useState(false);

    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()

        let filteredContracts = contracts;
        if (type === 'memo') {
            filteredContracts = contracts.filter(c => c.vehicule!.codeProduit !== '7311_NVEI' && c.vehicule!.codeProduit !== '7311_VAE');
        }

        if (filteredContracts.length === 1) {
            submitRequest();
            return;
        }

        setPickerOpen(true);
    }

    const submitRequest = () => {
        requestDocument.mutate({
            contract: id_contrat,
            type,
            libelle: title
        })
    }

    return (
        <div className="text-center mx-auto">
            <Button
                type="button"
                onClick={handleClick}
                aria-haspopup="dialog"
                aria-expanded={pickerOpen}
                className="cursor-pointer text-white"
            >
                {title}
            </Button>

            <ContractPickerModal
                isOpen={pickerOpen}
                onClose={() => setPickerOpen(false)}
                onSelect={submitRequest}
                contracts={contracts}
            />
        </div>
    )
}

export default RequestDocument;
